// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.normal-file-j0pAsA{-moz-column-gap:8px;background-color:#f7f7fa;border-radius:8px;align-items:center;column-gap:8px;max-width:252px;padding:12px;display:flex;position:relative}.normal-file-j0pAsA .file-icon-NZMe1v{width:28px;height:36px}.normal-file-j0pAsA .file-info-zRZ0Sf{flex-direction:column;row-gap:4px;font-size:12px;line-height:16px;display:flex;overflow:hidden}.normal-file-j0pAsA .file-info-zRZ0Sf .file-name-BHZavv{color:#2e2e38;font-weight:600}.normal-file-j0pAsA .file-info-zRZ0Sf .file-text-uj7LjK{color:#6b6b75;font-weight:400}.normal-file-j0pAsA .retry-button-wzLuru{color:#6b6b75;margin-left:auto}.normal-file-not-success-xaky93 .file-icon-NZMe1v{opacity:.4}.normal-file-not-success-xaky93 .file-info-zRZ0Sf .file-name-BHZavv{color:#7e7e86}.normal-file-not-success-xaky93 .file-info-zRZ0Sf .file-text-uj7LjK{color:#9c9ca4}.normal-file-not-success-xaky93 .file-info-zRZ0Sf .file-error-text-af5KRP{color:#fc8c76;font-weight:400}.progress-mask-ux56Hz{background:rgba(0,0,0,.06);border-radius:8px;height:100%;position:absolute;top:0;left:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"normal-file": `normal-file-j0pAsA`,
	"normalFile": `normal-file-j0pAsA`,
	"file-icon": `file-icon-NZMe1v`,
	"fileIcon": `file-icon-NZMe1v`,
	"file-info": `file-info-zRZ0Sf`,
	"fileInfo": `file-info-zRZ0Sf`,
	"file-name": `file-name-BHZavv`,
	"fileName": `file-name-BHZavv`,
	"file-text": `file-text-uj7LjK`,
	"fileText": `file-text-uj7LjK`,
	"retry-button": `retry-button-wzLuru`,
	"retryButton": `retry-button-wzLuru`,
	"normal-file-not-success": `normal-file-not-success-xaky93`,
	"normalFileNotSuccess": `normal-file-not-success-xaky93`,
	"file-error-text": `file-error-text-af5KRP`,
	"fileErrorText": `file-error-text-af5KRP`,
	"progress-mask": `progress-mask-ux56Hz`,
	"progressMask": `progress-mask-ux56Hz`
};
export default ___CSS_LOADER_EXPORT___;
